var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgVegan(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 24.915,
    viewBox: "0 0 12 24.915",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1315",
    "data-name": "Group 1315",
    transform: "translate(-109 -426.085)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "MDI_food-apple-outline",
    "data-name": "MDI / food-apple-outline",
    transform: "translate(75 349.085)",
    opacity: 0.999
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_food-apple-outline",
    "data-name": "Path / food-apple-outline",
    d: "M15.208,7.815A3.735,3.735,0,0,0,10.246,6.4V2.852H8.828V6.4A3.735,3.735,0,0,0,3.865,7.815C2.447,9.942,5.992,16.322,7.41,16.322s1.418-.709,2.127-.709.709.709,2.127.709,4.963-6.38,3.545-8.507m-1.241,2.4A10.923,10.923,0,0,1,11.451,14.9a.685.685,0,0,1-.425-.177,2.369,2.369,0,0,0-2.978,0,.685.685,0,0,1-.425.177,10.823,10.823,0,0,1-2.517-4.686,2.71,2.71,0,0,1-.064-1.609A2.389,2.389,0,0,1,7.055,7.39,2.654,2.654,0,0,1,8.2,7.666l.631.319h1.418l.631-.319a2.654,2.654,0,0,1,1.141-.276A2.382,2.382,0,0,1,14.031,8.6a2.71,2.71,0,0,1-.064,1.609M8.828,4.27c-3.984,2.176-4.885-.865-4.885-.865S5.829.86,8.828,4.27Z",
    transform: "translate(30.463 74.507)"
  })), /*#__PURE__*/React.createElement("text", {
    id: "VE",
    transform: "translate(110 449)",
    fontSize: 8,
    fontFamily: "HelveticaNeue-Bold, Helvetica Neue",
    fontWeight: 700
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "VE")))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVegan);
export default __webpack_public_path__ + "static/media/vegan.6bb18b3ddc9b33240039bab9a171376c.svg";
export { ForwardRef as ReactComponent };